/**
 * v0.4.37 Q4 — client-safety masking helpers.
 *
 * The IOSS IM number is a regulatory-confidential identifier
 * (Council Implementing Regulation 2019/2026, Article 369q). It
 * must not appear unmasked in any UI surface that could be
 * screen-shared or screenshot-shared with a third party. The
 * full unmasked value is editable inside the client profile
 * form (`ClientEditForm`) only. Every other surface uses
 * `maskIossImNumber()`.
 *
 * Format spec (Q4A=a, operator sign-off 2026-06-04):
 *   `IM` + 10 digits  ->  `IM**...**XYZ`
 *   where `XYZ` are the last 3 digits of the IM number.
 *
 * Inputs that don't match the IM\d{10} shape return the raw
 * input unchanged (callers should validate format before
 * passing to the mask). `null` / `undefined` / `""` return `""`.
 */
const IM_RE = /^IM\d{10}$/i;

export const maskIossImNumber = (value) => {
  if (!value) return "";
  const v = String(value).trim().toUpperCase();
  if (!IM_RE.test(v)) return v;
  return `IM**...**${v.slice(-3)}`;
};
